import { forwardRef, ReactNode } from "react";
import DatePicker, { DatePickerProps } from "react-datepicker";
import { DATE_FORMAT } from "../../../utils/constants";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";

type CustomInputProps = {
	value?: string;
	onClick?: () => void;
	placeholder?: string;
	icon?: ReactNode;
};

const CustomInput = forwardRef<HTMLButtonElement, CustomInputProps>(
	({ value, onClick, placeholder, icon }, ref) => (
		<button type="button" className="custom-date" onClick={onClick} ref={ref}>
			<span className={value ? "" : "custom-date__placeholder"}>
				{value || placeholder}
			</span>
			{icon ? <span className="custom-date__icon">{icon}</span> : null}
		</button>
	),
);
CustomInput.displayName = "CustomInput";

type RhfDatePickerProps = {
	name?: string;
	label?: string;
	value: Date | null;
	onChange: (date: Date | null) => void;
	error?: string;
	placeholder?: string;
	icon?: ReactNode;
} & Omit<Partial<DatePickerProps>, "selected" | "onChange" | "value">;

const RhfDatePicker = ({
	name,
	label,
	value,
	onChange,
	error,
	placeholder,
	icon,
	...props
}: RhfDatePickerProps) => (
	<div className="date-picker-container">
		{label && <div className="date-label">{label}</div>}
		<DatePicker
			// biome-ignore lint/suspicious/noExplicitAny: react-datepicker's
			// DatePickerProps is a discriminated union over selectsRange /
			// selectsMultiple that JSX inference cannot satisfy from a Partial
			// spread without forcing one variant.
			{...(props as any)}
			name={name}
			dateFormat={DATE_FORMAT}
			selected={value}
			onChange={onChange}
			className={`date-input ${error ? "error" : ""}`}
			customInput={
				<CustomInput
					placeholder={placeholder ?? props.placeholderText}
					icon={icon}
				/>
			}
		/>
		{error && <span className="error-message mt-1">{error}</span>}
	</div>
);

export { RhfDatePicker };
